var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group row" }, [
    _c("div", { staticClass: "col-md-12" }, [
      _c("label", [_vm._v("Currency")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c(
            "multiselect",
            {
              attrs: {
                options: _vm.options,
                placeholder: "Select Currencies",
                "group-values": "currencies",
                "group-label": "language",
                "group-select": true,
                multiple: true,
                label: "title",
                "track-by": "currency_id",
              },
              on: { input: _vm.onChange },
              model: {
                value: _vm.business.currency_id,
                callback: function ($$v) {
                  _vm.$set(_vm.business, "currency_id", $$v)
                },
                expression: "business.currency_id",
              },
            },
            [
              _c("span", { attrs: { slot: "noResult" }, slot: "noResult" }, [
                _vm._v(
                  "Oops! No elements found. Consider changing the search query."
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-12" }, [
      _c("br"),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: { type: "submit" },
          on: {
            click: function ($event) {
              return _vm.updateBusinessLocation()
            },
          },
        },
        [_vm._v("Submit")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }